const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const NUMBER = /^\d+$/;
// Firestore auto ids: 20 alphanumerics. Requiring a digit keeps long
// camelCase path words (function names) intact.
const FIRESTORE_ID = /^(?=.*\d)[A-Za-z0-9]{20,}$/;

const isIdSegment = (segment: string) =>
  UUID.test(segment) || NUMBER.test(segment) || FIRESTORE_ID.test(segment);

// A request url reduced to its endpoint: no query string or hash, and id-like
// path segments replaced with ":id". Used to name Sentry errors, so one
// endpoint's failures group into one issue rather than one per id.
const toEndpointPath = (url: string): string => {
  const [path] = url.split(/[?#]/);
  return path
    .split('/')
    .map((segment) => (isIdSegment(segment) ? ':id' : segment))
    .join('/');
};

export default toEndpointPath;
